import { format } from "date-fns";
import { fr } from "date-fns/locale";

import InformationRow from "../StyledComponents/InformationRow";

type Props = {
  carPickUpDate: Date;
};

function DateTimeSection({ carPickUpDate }: Props) {
  return (
    <>
      <InformationRow
        title="Date de livraison"
        value={format(carPickUpDate, "EEEE dd MMMM yy", { locale: fr })}
      />
      {/* <InformationRow
      title='Heure estimée de livraison'
      value={
        'Entre ' +
        deliverySmsMessageTime(clientEstimatedDeliveryDate, -15) +
        ' et ' +
        deliverySmsMessageTime(clientEstimatedDeliveryDate, 15)
      }
    /> */}
    </>
  );
}

export default DateTimeSection;
